export function getWidgetInputLayout() {
  return {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
  };
}
